import { headers } from "./settings";
import { Flex, HStack, Icon, IconButton } from "@chakra-ui/react";
import { useMemo, useRef, useState, useEffect } from "react";

import { useServicePermission } from "./servicePermitions";
import { Outlet } from "react-router-dom";
import Header from "@/modules/Relatorio/components/Header";
import { MdFilterList } from "react-icons/md";

import { AddIcon } from "@chakra-ui/icons";
import { FaClone } from "react-icons/fa";
import Select from "react-select";
import { Filter } from "./components/Filter";
import { FormField } from "@/utils/FormField";

export type TUsuarioRotina = {
  ativo: boolean;
  idempresa: number;
  idrotina: number;
  idusuario: number;
  idmenu: number;
  nome: string;
  nomemenu: string;
  nomerotina: string;
};

export function PermissaoUsuariosList() {
  const [isFilterVisible, setIsFilterVisible] = useState(false);
  const [filters, setFilters] = useState<any>({
    idmenu: undefined,
    idrotina: undefined,
  });
  const [searchTerm, setSearchTerm] = useState('');
  const [visibleHeaders, setVisibleHeaders] = useState(headers);
  const printRef = useRef(null);

  const {
    onOpenAdd,
    listUsuario,
    onOpenClone,
    userSelected,
    setUserSelected,
    setCurrentPage,
    updateQueryParams,
  } = useServicePermission();

  const usuarioSelecionadoOption = useMemo(
    () => listUsuario?.find((u: any) => u.value === userSelected) ?? null,
    [listUsuario, userSelected],
  );

  useEffect(() => {
    const queryParams = {
      ...filters,
    };

    const cleanParams = Object.entries(queryParams)
      .filter(([_, value]) => value !== '' && value !== null && value !== undefined)
      .reduce((acc, [key, value]) => ({ ...acc, [key]: value }), {});

    updateQueryParams(cleanParams);
  }, [searchTerm, filters, updateQueryParams]);

  const Filters = (data: any) => {
    setFilters(data);
  }

  return (
    <div className="flex flex-1 gap-3 p-4">
      <Outlet />
      <div className="w-full">
        <Header
          onHeadersChange={setVisibleHeaders}
          isFilterVisible={isFilterVisible}
          headers={visibleHeaders}
          isMenuEnabled
          onToggleFilter={() => setIsFilterVisible((prev) => !prev)}
          onView={Filters}
          printRef={printRef}
          title={'Permissão de Usuário'}
          searchTerm={searchTerm}
          setSearchTerm={setSearchTerm}
          disabledInputSearch
        />

        <Flex p={2} justifyContent="space-between" alignItems="center">
          <div className="w-[350px]">
            <FormField className="font-bold" label="Usuário:">
              <Select
                aria-label="Selecionador-Usuário"
                value={usuarioSelecionadoOption}
                onChange={(e) => {
                  setCurrentPage(0);
                  //@ts-ignore
                  setUserSelected(e?.value);
                }}
                options={listUsuario}
                placeholder="Selecione"
                styles={{
                  menuPortal: (base) => ({ ...base, zIndex: 99999 }),
                  menu: (base) => ({ ...base, zIndex: 99999 }),
                  control: (base, state) => ({
                    ...base,
                    borderRadius: 12,
                    borderColor: "#3B7F9F",
                    boxShadow: state.isFocused
                      ? `0 0 0 2px  "#3B7F9F"}`
                      : "none",
                    "&:hover": {
                      borderColor: "#3B7F9F",
                    },
                    minHeight: 36,
                    opacity: 1,
                    backgroundColor: base.backgroundColor,
                    cursor: "default",
                    height: 30,
                  }),
                  placeholder: (base) => ({
                    ...base,
                    color: "#ccc",
                  }),
                }}
              />
            </FormField>
          </div>

          <HStack>
            <IconButton
              aria-label="Add"
              icon={<AddIcon />}
              onClick={onOpenAdd}
              colorScheme="green"
              size="sm"
              borderRadius="full"
              isDisabled={!userSelected}
            />

            <IconButton
              aria-label="Edit"
              icon={<FaClone />}
              onClick={onOpenClone}
              colorScheme="blue"
              size="sm"
              borderRadius="full"
              isDisabled={!userSelected}
            />
          </HStack>
        </Flex>
      </div>
    </div>
  );
}
